import React from 'react';
import './ITSoftware.css';


function HealthCare() {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/healthcare_hero.png')" }}
      >
        <div className="hero-text-container">
          <h1>Health Care</h1>
          <p>Financial, compliance, and advisory support for hospitals, clinics, and med-tech ventures</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Finance with Care for the Healthcare Industry</h2>
          <p>We serve hospitals, diagnostic labs, clinics, and wellness startups with sector-specific financial and legal services.</p>
          <p>Our team assists in handling TDS on doctors' payments, medical equipment import tax, and NABH accounting standards.</p>
          <p>We guide med-tech and pharma firms on licensing, IP protection, and fundraising strategy.</p>
          <p>From patient billing models to CGHS panel audits, we ensure compliance and operational insight for the care economy.</p>
        </div>
        <div className="content-right">
          <img src="/images/healthcare.png" alt="Health Care Industry" />
        </div>
      </section>
    </div>
  );
}

export default HealthCare;
